export const Timezone: {
    Europe_Berlin: "Europe_Berlin",
    Europe_Lisbon: "Europe_Lisbon",
    Europe_London: "Europe_London",
    Europe_Paris: "Europe_Paris",
    Europe_Athens: "Europe_Athens",
    Europe_Moscow: "Europe_Moscow",
    Europe_Istanbul: "Europe_Istanbul",
    Asia_Dubai: "Asia_Dubai",
    Asia_Kolkata: "Asia_Kolkata",
    Asia_Bangkok: "Asia_Bangkok",
    Asia_Singapore: "Asia_Singapore",
    Asia_Tokyo: "Asia_Tokyo",
    Asia_Seoul: "Asia_Seoul",
    Australia_Sydney: "Australia_Sydney",
    Pacific_Auckland: "Pacific_Auckland",
    Pacific_Honolulu: "Pacific_Honolulu",
    America_Anchorage: "America_Anchorage",
    America_Los_Angeles: "America_Los_Angeles",
    America_Denver: "America_Denver",
    America_Chicago: "America_Chicago",
    America_New_York: "America_New_York",
    America_Sao_Paulo: "America_Sao_Paulo",
    America_Buenos_Aires: "America_Buenos_Aires",
    Atlantic_Reykjavik: "Atlantic_Reykjavik",
    Africa_Cairo: "Africa_Cairo",
    Africa_Johannesburg: "Africa_Johannesburg",
} = {
    Europe_Berlin: "Europe_Berlin",
    Europe_Lisbon: "Europe_Lisbon",
    Europe_London: "Europe_London",
    Europe_Paris: "Europe_Paris",
    Europe_Athens: "Europe_Athens",
    Europe_Moscow: "Europe_Moscow",
    Europe_Istanbul: "Europe_Istanbul",
    Asia_Dubai: "Asia_Dubai",
    Asia_Kolkata: "Asia_Kolkata",
    Asia_Bangkok: "Asia_Bangkok",
    Asia_Singapore: "Asia_Singapore",
    Asia_Tokyo: "Asia_Tokyo",
    Asia_Seoul: "Asia_Seoul",
    Australia_Sydney: "Australia_Sydney",
    Pacific_Auckland: "Pacific_Auckland",
    Pacific_Honolulu: "Pacific_Honolulu",
    America_Anchorage: "America_Anchorage",
    America_Los_Angeles: "America_Los_Angeles",
    America_Denver: "America_Denver",
    America_Chicago: "America_Chicago",
    America_New_York: "America_New_York",
    America_Sao_Paulo: "America_Sao_Paulo",
    America_Buenos_Aires: "America_Buenos_Aires",
    Atlantic_Reykjavik: "Atlantic_Reykjavik",
    Africa_Cairo: "Africa_Cairo",
    Africa_Johannesburg: "Africa_Johannesburg",
};

export type Timezone = (typeof Timezone)[keyof typeof Timezone]